<template>
  <div class="home-dialog-cpn">
    <el-dialog :visible.sync="dialogVisible"
               custom-class="home-dialog"
               @close="close"
               width="1000px">
      <!-- <div class="title-area">
        <div class="left-title-area">
          <div class="title-word">
            <span>魔镜·</span><span style="color: #3264f6">镜界AI</span>
          </div>
          <div class="sub-title">专为消费品商业分析打造的AI问答产品</div>
          <div class="experience-btn-area"
               @click="dialogVisible=false">
            <div class="experience-btn">
              <span style="margin-right: 20px;margin-left: 30px">立即体验</span>
              <img src="../assets/img/home-dialog/experience-right.png"
                   alt=""
                   style="width: 36px;height: 36px">
            </div>
            <img src="../assets/img/home-dialog/experience-left.png"
                 alt=""
                 style="width: 80px;position: absolute;top:-10px;left:-20px">
            <img src="../assets/img/home-dialog/play.png"
                 alt=""
                 style="width: 20px; position: absolute; top: 25px;right: 61px">
          </div>
        </div>
        <div class="right-title-area">
          <img src="../assets/img/home-dialog/right-title.png"
               alt=""
               style="width: 352px;">
        </div>
      </div>
      <div class="list-area">
        <div class="list-card-area">
          <div class="number-title">01</div>
          <div style="position: relative; z-index: 10">
            <div class="title">GPT做市场调研太水？</div>
            <span class="sub-title">镜界AI精通市场研究方法论</span>
            <div class="content">
              <div>桌面调研找报告</div>
              <div>详实市场数据支撑</div>
              <div>智能总结,一步到位</div>
            </div>
          </div>
        </div>
        <div class="list-card-area">
          <div class="number-title">02</div>
          <div style="position: relative; z-index: 10">
            <div class="title">都是公网上二手/广告信息？</div>
            <span class="sub-title">镜界AI坐拥魔镜电商数据库</span>
            <div class="content">
              <div>多平台电商数据</div>
              <div>消费者评论</div>
              <div>社媒话题···</div>
            </div>
          </div>
        </div>
        <div class="list-card-area">
          <div class="number-title">03</div>
          <div style="position: relative; z-index: 10">
            <div class="title">做次市场调研脱层皮？</div>
            <span class="sub-title">镜界AI帮你全方位提效</span>
            <div class="content">
              <div>节省80%工作时间</div>
              <div>一顿早饭的价格搞定一次市场调研</div>
            </div>
          </div>
        </div>
      </div> -->
      <img src="../assets/home-dialog.jpg"
           @click="dialogVisible=false"
           alt=""
           style="width: 100%">
    </el-dialog>
  </div>
</template>


<script>
export default {
  name: 'HomeDialog',
  data() {
    return {
      dialogVisible: false,
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  methods: {
    close() {
      this.dialogVisible = false
    },
  },
  watch: {
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal
      },
      immediate: true,
    },
  },
  created() {},
}
</script>

<style lang="less">
.el-dialog__wrapper {
  .home-dialog {
    border-radius: 10px;
    margin-top: 5vh !important;
    width: 100%;
    line-height: 0;
    // background-image: url('../assets/img/home-dialog/background.png');
    // background-size: cover;
    // background-position: center;
    // padding: 0 90px;
    // padding-bottom: 40px;
    .el-dialog__close {
      color: white;
      font-size: 20px;
      display: none;
    }
    .el-dialog__headerbtn {
      right: 27px;
    }
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
    }
    .title-area {
      padding-top: 80px;
      display: flex;
      .left-title-area {
        width: 540px;
        padding-top: 45px;
        .title-word {
          font-size: 65px;
          font-weight: bold;
          color: #27314a;
          margin-bottom: 10px;
          letter-spacing: 1px;
        }
        .sub-title {
          color: #27314a;
          font-size: 25px;
          letter-spacing: 1px;
        }
        .experience-btn-area {
          cursor: pointer;
          margin-top: 30px;
          background-image: url('../assets/img/home-dialog/experience-bg.png');
          background-size: cover;
          width: 300px;
          height: 72px;
          font-size: 25px;
          letter-spacing: 1px;
          color: white;
          text-align: center;
          line-height: 72px;
          position: relative;
          .experience-btn {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
    .list-area {
      margin-top: 20px;
      display: flex;

      .list-card-area {
        position: relative;
        margin-right: 10px;
        width: 300px;
        height: 160px;
        background-color: #fff;
        padding: 52px 0 0 25px;
        .number-title {
          position: absolute;
          top: 20px;
          left: 20px;
          color: #dbe7ff;
          font-size: 48px;
          z-index: 0;
        }
        .title {
          color: #1966ff;
          font-size: 18px;
          margin-bottom: 4px;
          font-weight: bold;
        }
        .sub-title {
          color: #1966ff;
          font-size: 14px;
          padding: 4px 8px;
          display: inline-block;
          background-image: url('../assets/img/home-dialog/content-bg.png');
          background-size: 100% 100%;
        }
        .content {
          font-size: 12px;
          color: #838383;
          div {
            margin-top: 5px;
          }
        }
      }
    }
  }
}
.home-dialog-cpn {
  cursor: pointer;
}
</style>
